module.exports = __webpack_public_path__ + "img/sd.761916d0.png";